(() => {
  const TRUSTPILOT_DATA_URL = 'https://widget.trustpilot.com/trustbox-data/5419b6ffb0d04a076446a9af?businessUnitId=64f7566379f5cdb0dae7adc6&locale=en-US';

  function formatReviewCount(n) {
    return n.toLocaleString('en-US') + '+';
  }

  async function fetchReviewsTotal() {
    try {
      const res = await fetch(TRUSTPILOT_DATA_URL);
      if (!res.ok) return null;
      const data = await res.json();
      return data?.businessUnit?.numberOfReviews?.total ?? null;
    } catch (e) {
      console.error('Trustpilot fetch failed', e);
      return null;
    }
  }

  async function injectReviewsCount() {
    const el = document.querySelector('.ig-hero-v2__reviews strong');
    if (!el) return;

    const total = await fetchReviewsTotal();
    if (total !== null) {
      el.textContent = formatReviewCount(total);
    }
    // si falla, se queda el valor default que ya esté hardcodeado en el HTML (fallback silencioso)
  }

  function bindPaginationToggle() {
    const splideRoot = document.querySelector('.main-carousel-splide');
    const slide = document.querySelector('#splide01-slide01');
    if (!splideRoot || !slide) return false;

    const pagination = splideRoot.querySelector(':scope > .splide__pagination');
    if (!pagination) return false;

    if (pagination.dataset.igPagBound === '1') return true;

    const PAG_ACTIVE_CLASS = 'ig-pagination-slide1-active';

    const syncState = () => {
      const isActive = slide.classList.contains('is-active') && slide.classList.contains('is-visible');
      pagination.classList.toggle(PAG_ACTIVE_CLASS, isActive);
    };

    const classObserver = new MutationObserver(syncState);
    classObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });

    syncState();
    pagination.dataset.igPagBound = '1';
    return true;
  }

  function run_code() {
    injectReviewsCount(); // no bloquea el resto, corre en paralelo
    const pagDone = bindPaginationToggle();
    if (pagDone) return;

    const observer = new MutationObserver(() => {
      const b = bindPaginationToggle();
      if (b) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      const b = bindPaginationToggle();
      if (b || attempts > 40) {
        clearInterval(interval);
        observer.disconnect();
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run_code);
  } else {
    run_code();
  }
})();